'use strict';

/******************************************** Ticket Product page *****************************/

$(document).ready(function() {
  // Create the HTML to be inserted
  const transcyDesktop = '<div class="transcy-switcher-manual transcy-desktop hidden">';
  const transcyMobile = '<div class="transcy-switcher-manual transcy-mobile hidden"></div>';

  // Insert the HTML before the last <li> in the list
  $('.header__icons .list-menu.list-menu--inline li:last').before(transcyDesktop);
  $('.header__icons .list-menu.list-menu--inline li:last').before(transcyMobile);
});

$(document).ready(function() {

  $('.open-popup-link').magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-fade'
  });  


  if ($('.fc-event-title-container').length) {
    let _eventTitleContainer = $('.fc-event-title-container').first();
    let _dayCell = _eventTitleContainer.closest('.fc-daygrid-day');
    let _scroller = $('.fc-scroller');
    
    if (_dayCell.length && _scroller.length) {
        let scrollTop = _dayCell.offset().top - _scroller.offset().top + _scroller.scrollTop() - 30;
        let scrollLeft = _dayCell.offset().left - _scroller.offset().left + _scroller.scrollLeft();
        
        _scroller.animate({
            scrollTop: scrollTop,
            scrollLeft: scrollLeft
        }, 500);
    }

  }

    $('body').on('click touchstart', '.event-ticketing-time-options a', function() {
        var get_selected_date_time = $(this).text();        
        var get_selected_date = $("#event-ticketing-events-container h3").text();        
        var str2_date_cmp = "Wednesday, April 16, 2025";

      /*
        if(get_selected_date.indexOf(str2_date_cmp) != -1){
        //    alert("The windmill will be closed today for a private event.");
            $(".popup__content_title").text("The windmill will be closed today for a private event.");
            $(".alert_popup").fadeIn(500);
        }    
      */
      //alert(get_selected_date);

      
      var get_selected_obj = $(this).closest(".event-container");
        if(get_selected_date_time == "4:00 PM - 6:00 PM" || get_selected_date_time == "4:00 PM"){
           // $(".popup__content_title").text("Last entry to the farm is 5:00pm sharp!");
          //  $(".alert_popup").fadeIn(500);        
            get_selected_obj.find("h3").each(function(){  
                var get_heading_title_org = $(this).attr("data-org-text");  
                var get_heading_title = $(this).text();
                if (typeof get_heading_title_org === "undefined") {              
                    $(this).attr("data-org-text",get_heading_title);
                    $(this).html(get_heading_title+'<span class="msg_subtitle_text">Last entry to the farm is 5:00pm sharp!</span>');                
                }else{
                    $(this).html(get_heading_title_org+'<span class="msg_subtitle_text">Last entry to the farm is 5:00pm sharp!</span>');                
                }                
            });            
        }else{
            $("#event-ticketing-events-container h3").each(function(){              
                get_selected_obj.find("h3").each(function(){              
                    var get_heading_title_org = $(this).attr("data-org-text");   
                    var get_heading_title = $(this).text(); 
                    if (typeof get_heading_title_org === "undefined") {
                        $(this).html(get_heading_title);                
                    }else{
                        $(this).html(get_heading_title_org);                
                    }                  
                    
                });                
            });            
        }
    });  

    $('body').on('click touchstart', '#event-ticketing-calendar-container td.fc-day .fc-daygrid-day-frame', function() {
      var click_date = $(this).closest(".fc-daygrid-day").attr("data-date");
        //alert("gkg");   
        setTimeout(function(){

            var get_selected_date = $("#event-ticketing-events-container h3").text();        
            
            var str2_date_cmp = "Wednesday, April 16, 2025";
          
            if(get_selected_date.indexOf(str2_date_cmp) != -1){            
                $(".popup__content_title").text("The windmill will be closed for a private event. The farm will still be open with all activities available.");
                $(".alert_popup").fadeIn(500);
            }             
            //alert(click_date);
            if(click_date == "2025-11-27" || click_date == "2025-12-24" || click_date == "2025-12-25"){
                $(".popup__content_title").text("The event will be closed today.");
                $(".popup__content_title").css("color","red");
                $(".alert_popup").fadeIn(500);
            }

         
                      
            $("#event-ticketing-events-container h2").each(function(){              
                var get_heading_title = $(this).text();
                if(get_heading_title == "U-Pick Tulips: Spring Spectacular"){
                  $(this).html('General Admission <span class="subtitle_text">Tickets are non-refundable. Age 3 and up need a ticket to enter. No pets, ESAs, or drones.</span>');
                }

                if(get_heading_title == "U-Pick Sunflowers: Fall Festival"){                  
                  $(this).html('General Admission <span class="subtitle_text">Tickets are non refundable but can be changed up to 9am on the day of your visit for free to a new date/time. Age 3 and up need a ticket to enter. Last ticket sold at 4:30pm. No pets, ESAs or drones are permitted.</span>');
                }

                if(get_heading_title == "Private Gator Service"){
                  $(this).html('Private Gator Service <span class="subtitle_text">Ride around the farm in style with one of our chauffeur driven gators. Admission into the windmill is also included! Note, you must also buy a ticket to enter the farm.</span>');
                }   
                
                
                if(get_heading_title.indexOf("Picnic Pad") != -1){  
                  $(this).html('Picnic Pad <span class="subtitle_text">Unwind in one of our 3 uniquely styled picnic decks - Sunny Honey, Pumpkin Patch, and Boots & Blooms. Perfect for relaxing and snacking with friends and family. Seating for 6 adults.</span>');
                }    
                
                if(click_date == "2025-12-18" || click_date == "2025-12-19" || click_date == "2025-12-20"){
                    //alert(get_heading_title); 
                    if(get_heading_title.indexOf("U-Pick Tulips Winter Wonderland 2025") != -1){  
                      $(this).html('U-Pick Tulips Winter Wonderland 2025 <span class="subtitle_text">Drone show nights! Watch the sky come alive above our authentic Dutch windmill with a 10–15 minute drone light show set to music. A breathtaking holiday spectacle for the whole family. Two shows at 6pm and 8pm.</span>');
                    }                      
                }                                 
            });                
        },100);      

      
    });    
  
    $(".alert_popup .close").click(function() {
      $(".alert_popup").fadeOut(500);
    });
      
  
});$(document).ready(function(){$(document).on('click', '.close_menu', function(){
    $('.header__icon--menu.header__icon--summary').trigger('click');
  });
  
  //slider-general
  $('.slider-logo').slick({
    infinite: true,
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 100,
    slidesToShow: 7,
    slidesToScroll: 1,
    pauseOnHover:true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  //slider-inner-slider
  $('.slider-inner-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px'
        }
      },
      {
        breakpoint: 750,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '20px'
        }
      }
    ]
  });

  $(window).resize(function(){
    $('.slider-inner-slider')[0].slick.refresh();
  });
  
  $('.slider-inside').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  });

  $(window).resize(function(){
    $('.slider-inside')[0].slick.refresh();
  });

  $(document).on('click', '#closeBtn', function(){
    $('#mainPopup').addClass('hidden');
  });
  
});

// Tab menu
function openTab(evt, tabName) {
  var i, tabcontent, tablinks;

  // Get tab content elements
  tabcontent = document.getElementsByClassName("tabcontent");
  
  // Only proceed if there is tab content
  if (tabcontent.length > 0) {
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"; // Hide all tab contents
    }
    
    // Get tab link elements
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", ""); // Remove "active" class
    }
    
    // Show the active tab content
    var activeTab = document.getElementById(tabName);
    if (activeTab) {
      activeTab.style.display = "block"; // Show the active tab content
      evt.currentTarget.className += " active"; // Set the current tab as active
    }
  }
}

// Check for defaultOpen and click it if it exists
var defaultOpenTab = document.getElementById("defaultOpen");
if (defaultOpenTab) {
  defaultOpenTab.click(); // Trigger the default tab click if it exists
}

// Ensure jQuery is loaded
console.log('jQuery loaded:', typeof jQuery !== 'undefined');

$(document).ready(function() {
    if ($('.scrolling-nav-wrapper').length) {
        var div_top = $('.scrolling-nav-wrapper').offset().top;
        var lastScrollTop = $(window).scrollTop(); // Track last scroll position

        $(window).scroll(function() {
            var window_top = $(window).scrollTop();
            var currentScrollTop = $(window).scrollTop();

            if (window_top > div_top && currentScrollTop > lastScrollTop) {
                // Add 'sticky' class only when scrolling down
                $('.scrolling-nav-wrapper').addClass('sticky');
            } else if (currentScrollTop < lastScrollTop) {
                // Remove 'sticky' class when scrolling up
                $('.scrolling-nav-wrapper').removeClass('sticky');
            }

            lastScrollTop = currentScrollTop; // Update last scroll position
        });
    } else {
        console.warn('No scrolling-nav-wrapper found.');
    }

    var topMenuHeight = $(".scrolling-nav-container").outerHeight();
    $('.scrolling-nav-container').menuScroll(topMenuHeight);
});


// Function to scroll the active navigation item into the center of the container
function scrollActiveNavItemToCenter() {
    const activeItem = $('.scroll-nav-button.active');
    const container = $('.scrolling-nav-container');

    if (activeItem.length) {
        const itemOffsetLeft = activeItem.offset().left;
        const containerOffsetLeft = container.offset().left;
        const containerScrollLeft = container.scrollLeft();
        const containerWidth = container.width();
        const itemWidth = activeItem.outerWidth();

        // Calculate the new scroll position for centering the active item
        const newScrollPosition = containerScrollLeft + itemOffsetLeft - containerOffsetLeft - (containerWidth / 2) + (itemWidth / 2);

        // Scroll the container horizontally to the calculated position
        container.animate({ scrollLeft: newScrollPosition }, 300);
    }
}

// Extend jQuery with the menuScroll function to handle section scroll and active class changes
jQuery.fn.extend({
    menuScroll: function() {
        const topMenu = this;
        const menuItems = $(topMenu).find("a");
        let lastId;

        // Create an array of target section elements corresponding to menu items
        const scrollItems = $(menuItems).map(function() {
            const hrefValue = $(this).attr("href");
            // Check if hrefValue is valid and corresponds to an existing element
            if (hrefValue && hrefValue.startsWith('#')) {
                const item = $(hrefValue); // Get the item using the href value
                if (item.length) return item; // Only include valid items
            }
        });

        // Smooth scroll on menu item click
        $(topMenu).on("click", "a", function(e) {
            const hrefValue = $(this).attr("href");
            console.log('href:', hrefValue); // Log the href value

            // Ensure hrefValue starts with '#' and is not empty
            if (hrefValue && hrefValue.startsWith('#')) {
                const targetSection = $(hrefValue);
                if (targetSection.length) { // Check if the target section exists
                    const offsetTop = targetSection.offset().top; // Get the top offset of the target section

                    const isFirstItem = $(this).is(':first-child');
                    const navHeight = $('.scrolling-nav-container').outerHeight();
                    const adjustedOffsetTop = isFirstItem ? offsetTop - navHeight + 55 : offsetTop - navHeight;

                    // Animate scrolling to the section
                    $('html, body').stop().animate({ scrollTop: adjustedOffsetTop }, 300);
                    e.preventDefault(); // Prevent default action for smooth scrolling
                } else {
                    // If the section doesn't exist, allow the link to be followed
                    console.warn('No element found for:', hrefValue); // Warn if the element doesn't exist
                    // Remove e.preventDefault() to allow the navigation
                }
            } else {
                console.warn('Invalid href value:', hrefValue); // Log invalid href
                // Allow the navigation for non-anchor links
            }
        });

        // Highlight active menu item on page scroll
        $(window).scroll(function() {
            const fromTop = $(window).scrollTop() + $('.scrolling-nav-container').outerHeight(); // Dynamic offset for activation

            // Get the section that is currently in view
            let current = $(scrollItems).map(function() {
                if ($(this).offset().top <= fromTop) return this; // Check offset for section activation
            });

            // Get the last active section's id
            current = current[current.length - 1];
            const id = current && current.length ? current[0].id : "";

            if (lastId !== id) {
                lastId = id;

                // Update active menu item and trigger auto-scroll to center the active item
                $(menuItems).parent().removeClass("active")
                    .end().filter(`[href='#${id}']`).parent().addClass("active");
                
                scrollActiveNavItemToCenter(); // Center the active item within the container
            }
        });
    }
});

// Initialize the menuScroll function
$(document).ready(function() {
  if ($('.scrolling-nav-container').length) {
      $('.scrolling-nav-container').menuScroll();
  } else {
      console.warn('No scrolling-nav-container found.');
  };

  if ($('.cart__checkout-button').length) {
    if ($('#agree').length) {
      $('body').on('click', '[name="checkout"]', function() {
        if ($('#agree').is(':checked')) {
          $(this).submit();
        }
        else {
          alert("You must agree with the terms and conditions to check out.");
          return false;
        }
        if ($('#agree-non-refundable').is(':checked')) {
          $(this).submit();
        }
        else {
          alert("You must acknowledge tickets are non-refundable to check out.");
          return false;
        }
      });
    }
  }
});

